var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3566 10.0002L19.5113 2.84536C20.1629 2.1937 20.1629 1.14039 19.5113 0.48874C18.8596 -0.162913 17.8063 -0.162913 17.1547 0.48874L10 7.64359L2.8453 0.48874C2.19366 -0.162913 1.14037 -0.162913 0.48873 0.48874C-0.16291 1.14039 -0.16291 2.1937 0.48873 2.84536L7.64343 10.0002L0.48873 17.1551C-0.16291 17.8067 -0.16291 18.86 0.48873 19.5117C0.813716 19.8367 1.24036 20 1.66701 20C2.09366 20 2.52031 19.8367 2.8453 19.5117L10 12.3568L17.1547 19.5117C17.4797 19.8367 17.9063 20 18.333 20C18.7596 20 19.1863 19.8367 19.5113 19.5117C20.1629 18.86 20.1629 17.8067 19.5113 17.1551L12.3566 10.0002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modal-close-icon.15929401b5f2cdb0756b71ad8f123f9d.svg";
export { ForwardRef as ReactComponent };